// from packages/web/src/api/jwtAuth/index.ts
export type HttpErrorCode =
  | 'INVALID_CREDENTIALS'
  | 'INVALID_DATA'
  | 'UNKNOWN_ERROR'
  | 'REFRESH_TOKEN_EXPIRED'
  | 'ORGANIZATION_NOT_FOUND'
  | 'ORGANIZATION_ACCESS_DENIED';

export const isHttpErrorCode = (code: unknown): code is HttpErrorCode => {
  return (
    typeof code === 'string' &&
    [
      'INVALID_CREDENTIALS',
      'INVALID_DATA',
      'UNKNOWN_ERROR',
      'REFRESH_TOKEN_EXPIRED',
      'ORGANIZATION_NOT_FOUND',
      'ORGANIZATION_ACCESS_DENIED',
    ].includes(code)
  );
};

export type LoginResultSuccess = { accessToken: string };
export const isLoginResultSuccess = (
  result: unknown,
): result is LoginResultSuccess => {
  return (
    typeof result === 'object' &&
    result !== null &&
    'accessToken' in result &&
    typeof result.accessToken === 'string' &&
    result.accessToken?.length > 0
  );
};

export type LoginResultError = {
  error: { code: HttpErrorCode; message?: string };
};
export const isLoginResultError = (
  result: unknown,
): result is LoginResultError => {
  return (
    typeof result === 'object' &&
    result !== null &&
    'error' in result &&
    isHttpErrorCode((result as LoginResultError).error?.code)
  );
};

export const getLoginErrorCode = (
  result: unknown,
): HttpErrorCode | undefined => {
  if (isLoginResultError(result)) {
    return result.error.code;
  }
  return undefined;
};

export type LoginResult = LoginResultSuccess | LoginResultError;
